import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {IUser} from "../../interfaces";
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import {AppService, StoreSelectorsService} from "../../services";
import {MatDialog} from "@angular/material/dialog";
import {Lib} from "../../../libs/Lib";
import {isHostDevOrLocal} from "../../common";

@Component({
    selector: 'app-upgrade-overlay',
    templateUrl: './upgrade-overlay.component.html',
    styleUrls: ['./upgrade-overlay.component.scss']
})
export class UpgradeOverlayComponent extends Compbaser {
    enterpriseMode: boolean;
    dashboard: boolean;
    accountStatus: boolean;
    showOverlay: boolean;
    showUpgradeButton = false;
    buttonText = '';
    user: IUser;

    constructor(private router: Router,
                private appService: AppService,
                private storeSelector: StoreSelectorsService,
                private translocoService: TranslocoService,
                public override dialog: MatDialog) {
        super();

        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                    if (isHostDevOrLocal()) {
                        this.showOverlay = false;
                        return;
                    }
                    this.enterpriseMode = Lib.GetIsEnterprise(this.user);
                    this.dashboard = Lib.GetAccountVersion(i_user) === 'DASH';
                    if (this.dashboard && Lib.IsResellerStatusActive(this.user)) {
                        this.showOverlay = false;
                    } else if (this.dashboard && !Lib.IsResellerStatusActive(this.user)) {
                        this.showOverlay = true;
                    } else if (this.enterpriseMode) {
                        this.showOverlay = true;
                    } else {
                        this.showUpgradeButton = true;
                        this.showOverlay = true;
                        this.buttonText = this.translocoService.translate('general.blockAccessEnterprise', {}, this.translocoService.getActiveLang());
                    }
                })
        );
    }

    upgrade() {
        this.appService.openWizardUpgradeDialog();
        this.router.navigateByUrl('/home');
    }
}
